





















































































































































import { defineComponent, reactive, toRefs, ref, onMounted, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import moment from 'moment'
import { BModal } from 'bootstrap-vue';
import AlertArea from "../../components/AlertArea.vue"
import SumupResultRankTab from "../../components/SumupResultRankTab.vue"
import { SumupGroup, RankResult, Assessment, SearchCondtion, getPassingTextFixed } from "../../modules/teacher/PracticeSumupResultRankListTotal"

export interface Data {
  sumup_group_id: string
  curriculum_id: string
  condition: SearchCondtion
  sumupGroup: SumupGroup
  rankResults: RankResult[]
  rows: any[]
  filteredRankResults: RankResult[]
  passingStateFixedEditTarget: RankResult
  assessments: Assessment[]
  curriculumIds: number[]
  fields: any[]
  colNames: string[]
  isAllCheckedPublishing: boolean
  isAllCheckSumup: boolean
  passingCount103: number
  passingCount104: number
  passingCountFixed: number
  subPassingCount103: number
  subPassingCount104: number
  subPassingCountFixed: number
  errors: string[]
  isInit: boolean
}

export default defineComponent({
  components: {
    "sumup-result-rank-tab": SumupResultRankTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const passingStateFixedRef = ref<InstanceType<typeof BModal>>();
    const passingScoreModalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: "",
      curriculum_id: "",
      sumupGroup: null,
      condition: new SearchCondtion(),
      rankResults: [],
      rows: [],
      filteredRankResults: [],
      passingStateFixedEditTarget: null,
      assessments: [],
      curriculumIds: [],
      fields: [],
      colNames: [],
      isAllCheckedPublishing: false,
      isAllCheckSumup: false,
      passingCount103: null,
      passingCount104: null,
      passingCountFixed: null,
      subPassingCount103: null,
      subPassingCount104: null,
      subPassingCountFixed: null,
      errors: new Array<string>(),
      isInit: false,
    });

    /******************************
     * 集計列 ヘッダーチェックボックス
     ******************************/

    watch(() => state.isAllCheckSumup, (newVal, oldVal) => {
      state.filteredRankResults.forEach(x => x.rowObject["isSelected"] = newVal);
    });

    /******************************
     * 公開列 ヘッダーチェックボックス
     ******************************/

    watch(() => state.isAllCheckedPublishing, (newVal, oldVal) => {
      state.filteredRankResults.forEach(x => x.rowObject["result_published"] = newVal);
    });

    /******************************
     * 備考モーダル表示
     ******************************/

    const showPassingStateFixedModal = (student_no_character: string) => {
      state.passingStateFixedEditTarget = state.rankResults.filter(x => x.student_no_character == student_no_character)[0];
      passingStateFixedRef.value.show();
    }

    /******************************
     * 3科合格点更新
     ******************************/

    watch(() => [state.sumupGroup.passing_score_103, state.sumupGroup.passing_score_104, state.sumupGroup.sub_passing_score_103, state.sumupGroup.sub_passing_score_104], () => {
      if(!state.isInit){
        state.isInit = true;
        return;
      }
      sumupPassingState();
      search();
    },{immediate: false});

    const sumupPassingState = () => {

      // 合否判定をクリア
      state.rankResults.forEach(x => {
        x.passing_state_103 = null;
        x.passing_state_104 = null;
        x.passing_state_fixed = null;
        x.rowObject["passing_state_103"] = "-";
        x.rowObject["passing_state_104"] = "-";
        x.rowObject["passing_state_fixed"] = "-";
      });

      state.passingCount103 = 0;
      state.passingCount104 = 0;
      state.passingCountFixed = 0;
      state.subPassingCount103 = 0;
      state.subPassingCount104 = 0;
      state.subPassingCountFixed = 0;

      // 合格点・補欠合格点に一つでも未入力がある場合は判定を行わない
      if(!state.sumupGroup.passing_score_103 || !state.sumupGroup.passing_score_104 || !state.sumupGroup.sub_passing_score_103 || !state.sumupGroup.sub_passing_score_104){
        return;
      }

      state.rankResults.forEach(x => {
        const curriculumResult103 = x.curriculumResults.filter(x => x.curriculum_id == 103)[0];
        const curriculumResult104 = x.curriculumResults.filter(x => x.curriculum_id == 104)[0];

        // 3科判定
        if(!curriculumResult103.is_absent){
          if(curriculumResult103.score >= state.sumupGroup.passing_score_103){
            x.passing_state_103 = Common.PassingStateEnum.Pass;
            x.rowObject["passing_state_103"] = "○";
            state.passingCount103++;
          }else if(curriculumResult103.score >= state.sumupGroup.sub_passing_score_103){
            x.passing_state_103 = Common.PassingStateEnum.Sub;
            x.rowObject["passing_state_103"] = "△";
            state.subPassingCount103++;
          }else{
            x.passing_state_103 = Common.PassingStateEnum.Fail;
            x.rowObject["passing_state_103"] = "×";
          }
        }

        // 4科判定
        if(!curriculumResult104.is_absent){
          if(curriculumResult104.score >= state.sumupGroup.passing_score_104){
            x.passing_state_104 = Common.PassingStateEnum.Pass;
            x.rowObject["passing_state_104"] = "○";
            state.passingCount104++;
          }else if(curriculumResult104.score >= state.sumupGroup.sub_passing_score_104){
            x.passing_state_104 = Common.PassingStateEnum.Sub;
            x.rowObject["passing_state_104"] = "△";
            state.subPassingCount104++;
          }else{
            x.passing_state_104 = Common.PassingStateEnum.Fail;
            x.rowObject["passing_state_104"] = "×";
          }
        }

        // 合格判定
        if(!curriculumResult104.is_absent){
          // 4科受験の合格判定
          if(x.passing_state_104 == Common.PassingStateEnum.Pass){
            x.passing_state_fixed = Common.PassingStateEnum.Pass;
            x.rowObject["passing_state_fixed"] = "合格";
            state.passingCountFixed++;
          }else if(x.passing_state_104 == Common.PassingStateEnum.Sub){
            x.passing_state_fixed = Common.PassingStateEnum.Sub;
            x.rowObject["passing_state_fixed"] = "補欠合格";
            state.subPassingCountFixed++;
          }else{
            x.passing_state_fixed = Common.PassingStateEnum.Fail;
            x.rowObject["passing_state_fixed"] = "不合格";
          }
        }else if(!curriculumResult103.is_absent){
          // 3科受験の合格判定
          if(x.passing_state_103 == Common.PassingStateEnum.Pass){
            x.passing_state_fixed = Common.PassingStateEnum.Pass;
            x.rowObject["passing_state_fixed"] = "合格";
            state.passingCountFixed++;
          }else if(x.passing_state_103 == Common.PassingStateEnum.Sub){
            x.passing_state_fixed = Common.PassingStateEnum.Sub;
            x.rowObject["passing_state_fixed"] = "補欠合格";
            state.subPassingCountFixed++;
          }else{
            x.passing_state_fixed = Common.PassingStateEnum.Fail;
            x.rowObject["passing_state_fixed"] = "不合格";
          }
        }
      });
    }

    /******************************
     * 検索
     ******************************/

    const search = () => {
      let filteredRankResults = state.rankResults.map(x => x);
      if(state.condition.student_no_character){
        filteredRankResults = state.rankResults.filter(x => x.student_no_character == state.condition.student_no_character);
      }
      if(state.condition.student_name){
        filteredRankResults = filteredRankResults.filter(x => x.student_name.includes(state.condition.student_name));
      }
      if(state.condition.applied_type){
        filteredRankResults = filteredRankResults.filter(x => x.applied_type == Number(state.condition.applied_type));
      }
      filteredRankResults.forEach(x => {
        x.rowObject["result_published"] = x.result_published_cache;
        x.rowObject["isSelected"] = false;
      });
      state.filteredRankResults = filteredRankResults;
      state.rows = state.filteredRankResults.map(x => x.rowObject);
    }

    /******************************
     * クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondtion();
    }

    /******************************
     * 判定設定モーダル表示
     ******************************/

    const showAssessmentModal = () => {
      passingScoreModalRef.value.show();
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "-";
    };

    /******************************
     * 一覧得点列のフォーマッター
     ******************************/

    const scoreFormatter = (value: any) => {
      return value == -1 ? "-" : `${value}点`;
    }

    /******************************
     * 一覧順位列のフォーマッター
     ******************************/

    const rankFormatter = (value: any) => {
      return value == 10000 ? "-" : `${value}位`;
    }

    /******************************
     * 一覧偏差値列のフォーマッター
     ******************************/

    const stdScoreFormatter = (value: any) => {
      return value == -1 ? "-" : `${value}`;
    }

    /******************************
     * 判定追加プラスアイコン押下
     ******************************/

    const addAssessment = () => {
      const newAssessment: any = {id: null, sumup_group_id: state.sumup_group_id, curriculum_id: 0, value: "", comment: ""};
      state.assessments.push(new Assessment(newAssessment));
    }

    /******************************
     * 合格点更新ボタン押下
     ******************************/

    const updatePassingScore = async () => {

      state.errors = [];
      
      if (!window.confirm('合格点を更新します。よろしいですか？')) {
        return;
      }

      const params: any = {
        sumup_group: state.sumupGroup,
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_total/update_passing_score`, params).then(response => {
        alert("処理が完了しました。");
        
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");

    }

    /******************************
     * 合否判定手動更新
     ******************************/

    const updatePassingStateFixed = async () => {

      if (!window.confirm('合否判定を手動変更します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_total/update_passing_score_fixed/${state.passingStateFixedEditTarget.practice_examinee_id}/${state.passingStateFixedEditTarget.passing_state_fixed}`).then(response => {
        const updatedExaminee = state.rankResults.filter(x => x.student_no_character == state.passingStateFixedEditTarget.student_no_character)[0];
        updatedExaminee.passing_state_fixed = state.passingStateFixedEditTarget.passing_state_fixed;
        updatedExaminee.rowObject["passing_state_fixed"] = getPassingTextFixed(updatedExaminee.passing_state_fixed);
        search();
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 公開変更ボタン押下
     ******************************/

    const updatePublished = async () => {

      if (!window.confirm('公開状態を変更します。よろしいですか？')) {
        return;
      }

      const examinees: any = [];
      state.filteredRankResults.forEach(x => examinees.push({student_no_character: x.student_no_character, result_published: x.rowObject["result_published"]}));

      if(examinees.length == 0){
        state.errors.push("対象の受験者が存在しません。");
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_total/update_published/${state.sumup_group_id}`, {examinees: examinees}).then(response => {
        alert("処理が完了しました。");
        
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 個別集計ボタン押下
     ******************************/

    const sumup = async () => {

      let practice_examinee_ids: any = [];
      practice_examinee_ids = state.filteredRankResults.filter(x => x.rowObject["isSelected"]).map(x => x.practice_examinee_id);

      if(practice_examinee_ids.length == 0){
        state.errors.push("対象の受験者が選択されていません。");
        return;
      }

      if (!window.confirm('選択している受験者の個別集計を行います。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_sumup_result_rank_list_total/sumup/${state.sumup_group_id}`, {"practice_examinee_ids": practice_examinee_ids}).then(response => {
        alert("処理が完了しました。");
        
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }
    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      //context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      state.curriculum_id = context.root.$route.params.curriculum_id == null ? "" : context.root.$route.params.curriculum_id;
      await http.get(`/api/teacher/practice_sumup_result_rank_list_total?sumup_group_id=${state.sumup_group_id}&curriculum_id=${state.curriculum_id}`).then(response => {
        state.sumupGroup = new SumupGroup(response.data.sumup_group);
        state.rankResults = response.data.rank_results.map((x: any) => new RankResult(x));
        state.filteredRankResults = response.data.rank_results.map((x: any) => new RankResult(x));
        state.rows = state.filteredRankResults.map(x => x.rowObject)
        state.curriculumIds = response.data.curriculum_ids;
        state.passingStateFixedEditTarget = state.rankResults[0];

        let colIdx = 0;
        for(let i = 0; i < state.curriculumIds.length * 3; i++){
          if(colIdx == 0){
            state.colNames.push("得点");
            colIdx++;
          }else if(colIdx == 1){
            state.colNames.push("順位");
            colIdx++;
          }else{
            state.colNames.push("偏差値");
            colIdx = 0;
          }
        }

        let curriculumConIdx = 0;
        const curriculumHeader = ["得点", "順位", "偏差値"];
        for(let i = 0; i < state.rankResults[0].colCount; i++){
          if(i + 1 == state.rankResults[0].colCount - 4){
            state.fields.push({key: "isSelected", label: "再集計", sortable: false, class: 'text-center b-table-th-td'});
          }else if(i + 1 == state.rankResults[0].colCount - 3){
            state.fields.push({key: "result_published", label: "公開", sortable: false, class: 'text-center b-table-th-td'});
          }else if(i + 1 == state.rankResults[0].colCount - 2){
            state.fields.push({key: "passing_state_104", label: "4科判定", sortable: true, class: 'text-center b-table-th-td'});
          }else if(i + 1 == state.rankResults[0].colCount - 1){
            state.fields.push({key: "passing_state_103", label: "3科判定", sortable: true, class: 'text-center b-table-th-td'});
          }else if(i + 1 == state.rankResults[0].colCount){
            state.fields.push({key: "passing_state_fixed", label: "合否", sortable: true, class: 'text-center b-table-th-td'});
          }else if(i == 0){
            state.fields.push({key: "student_no_character", label: "受験番号", sortable: true, class: 'text-center b-table-th-td'});
          }else if(i == 1){
            state.fields.push({key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'});
          }else if(i == 2){
            state.fields.push({key: "practice_examinee_id", label: "成績", sortable: false, class: 'text-center b-table-th-td'});
          }else if(i == 3){
            state.fields.push({key: "cram_school_name", label: "塾名", sortable: false, class: 'text-center b-table-th-td'});
          }else if(i == 4){
            state.fields.push({key: "cram_room_name", label: "教室名", sortable: false, class: 'text-center b-table-th-td'});
          }else if(i == 5){
            state.fields.push({key: "applied_type_name", label: "志願種別", sortable: false, class: 'text-center b-table-th-td'});
          }else if(curriculumConIdx == 0){
            state.fields.push({key: String(i), label: curriculumHeader[curriculumConIdx++], sortable: true, class: 'text-center b-table-th-td', formatter: 'scoreFormatter'});
          }else if(curriculumConIdx == 1){
            state.fields.push({key: String(i), label: curriculumHeader[curriculumConIdx++], sortable: true, class: 'text-center b-table-th-td', formatter: 'rankFormatter'});
          }else if(curriculumConIdx == 2){
            state.fields.push({key: String(i), label: curriculumHeader[curriculumConIdx++], sortable: true, class: 'text-center b-table-th-td', formatter: 'stdScoreFormatter'});
            curriculumConIdx = 0;
          }
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      passingStateFixedRef,
      passingScoreModalRef,
      convertExecDate,
      scoreFormatter,
      rankFormatter,
      stdScoreFormatter,
      showPassingStateFixedModal,
      showAssessmentModal,
      addAssessment,
      updatePassingScore,
      updatePublished,
      search,
      clearCondition,
      sumup,
      updatePassingStateFixed
    };
  }
});
